const GROUP_TYPE_LABELS = {
  custom: "Custom",
  first_time_guests: "First Time Guests",
  volunteers: "Volunteers",
  youth: "Youth",
  children: "Children",
  men: "Men",
  women: "Women",
  small_group: "Small Group",
  leadership: "Leadership",
  worship_team: "Worship Team",
};

export const GROUP_TYPE_OPTIONS = Object.entries(GROUP_TYPE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const groupTypeLabel = (type) => GROUP_TYPE_LABELS[type] || type;

const GROUP_ROLE_LABELS = {
  leader: "Leader",
  "co-leader": "Co-Leader",
  member: "Member",
};

export const groupRoleLabel = (role) => GROUP_ROLE_LABELS[role] || role;

const initialsOf = (name = "") => {
  const words = name.replace(/[^\p{L}\p{N}\s]/gu, " ").trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0]}${words[1][0]}`.toUpperCase();
};

const SWATCH_SIZES = {
  md: "h-10 w-10 text-sm",
  lg: "h-12 w-12 text-base",
};

// Light group colors (amber, cyan) need dark text to stay legible.
const prefersDarkText = (hex) => {
  const match = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!match) return false;
  const n = parseInt(match[1], 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((c) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b > 0.179;
};

/** Text color class for content placed on a group color. */
export const swatchTextClass = (hex) => (prefersDarkText(hex) ? "text-gray-900" : "text-white");

/**
 * The group's identity tile: its initials on the color chosen for the group.
 * The color is user data (picked on the group form), so it is applied inline.
 */
export const GroupSwatch = ({ group, size = "md" }) => (
  <span
    aria-hidden="true"
    className={`${SWATCH_SIZES[size]} flex shrink-0 items-center justify-center rounded-control font-bold ${swatchTextClass(
      group.color
    )} ${group.color ? "" : "bg-brand-500"}`}
    style={group.color ? { backgroundColor: group.color } : undefined}
  >
    {initialsOf(group.name)}
  </span>
);
